export default "__VITE_ASSET__c0853a83__"